import React from 'react'
import logo from '../../assets/images/logo.svg'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { CgChevronDown } from 'react-icons/cg'
import LanguageSelection from './languageSelection'
import { RiMenu2Fill } from "react-icons/ri";
import { changeShowMenu } from '../../redux/slices/showMenuSlice'
import { IoMdClose } from "react-icons/io";

const Header = () => {
    const { t } = useTranslation()
    const lang = useSelector((state) => state.lang.lang)
    const showMenu = useSelector((state) => state.showMenu.showMenu);
    const dispatch = useDispatch();

    return (
        <div className='header'>
            <div className='logo'><Link to="/"><img src={logo} alt='' /></Link></div>
            <div className='menu'>
                <div className='links'>
                    <ul>
                        <li><Link to={lang === "tr" ? "/about-us" : "/about-us"}>{t("about")}</Link></li>
                        <li>
                            <div>
                                <Link to={"#"}>{t("services")}</Link>
                                <CgChevronDown />
                            </div>
                            <ul className='sub-menu'>
                                <li><Link to={lang === "tr" ? "/software" : "/software"}>{t("software")}</Link></li>
                                <li><Link to={lang === "tr" ? "/hardware" : "/hardware"}>{t("hardware")}</Link></li>
                            </ul>
                        </li>
                        <li><Link to={lang === "tr" ? "/references" : "/references"}>{t("references")}</Link></li>
                        {/* <li><Link to={lang === "tr" ? "/career" : "/career"}>{t("career")}</Link></li> */}
                        <li><Link to={lang === "tr" ? "/contact" : "/contact"}>{t("contact")}</Link></li>
                    </ul>
                </div>
                {/* <LanguageSelection /> */}
                <div className='mobile-menu-btn' onClick={() => dispatch(changeShowMenu(!showMenu))}>
                    {showMenu ? <IoMdClose size={30} /> : <RiMenu2Fill size={30} />}
                </div>
            </div>
        </div>
    )
}

export default Header
